import { defineRouteMeta } from '@/router/helpers/defineRouteMeta';

export default [
  {
    path: '',
    name: 'client-occupiers-list',
    component: () => import(/* webpackChunkName: "client" */ '@/bundles/Occupier/views/OccupiersClientView.vue'),
    props: true,
    meta: defineRouteMeta({
      title: 'Occupiers',
      allowClientAccess: true,
      showMapSwitcher: true,
    }),
  },
  {
    path: ':id',
    name: 'client-occupier',
    component: () => import(/* webpackChunkName: "client" */ '@/bundles/Occupier/views/OccupierClientView.vue'),
    props: true,
    meta: defineRouteMeta({
      title: 'Occupier',
      allowClientAccess: true,
    }),
  },
];
